module.exports = __webpack_public_path__ + "img/logo-full-with-name.009fa447.png";